import { render } from "./TaskComment.vue?vue&type=template&id=43680d70&scoped=true"
import script from "./TaskComment.vue?vue&type=script&lang=js"
export * from "./TaskComment.vue?vue&type=script&lang=js"

import "./TaskComment.vue?vue&type=style&index=0&id=43680d70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43680d70"]])

export default __exports__